<template>
  <main class="legal-page">
    <article class="legal-content">
      <router-link class="back-link" to="/">← Retour à l'accueil</router-link>

      <h1>CONDITIONS GÉNÉRALES D'UTILISATION</h1>
      <p class="update-date">Dernière mise à jour : 15 juin 2026</p>

      <section>
        <h2>1. Objet</h2>
        <p>
          Les présentes Conditions Générales d'Utilisation ont pour objet de
          définir les conditions d'accès et d'utilisation du service Fidmarket.
        </p>
        <p>
          Fidmarket est une solution numérique destinée aux commerçants,
          notamment aux commerçants de marché, permettant de gérer un programme
          de fidélité, des cartes physiques ou digitales, des ventes, des
          journées de marché, des statistiques, des prévisions indicatives et
          des annonces visibles par les clients.
        </p>
        <p>L'utilisation du service implique l'acceptation des présentes CGU.</p>
      </section>

      <section>
        <h2>2. Accès au service</h2>
        <p>L'accès à Fidmarket s'effectue depuis une application web accessible en ligne.</p>
        <p>
          Certaines fonctionnalités nécessitent un compte commerçant et une
          authentification. L'utilisateur s'engage à conserver confidentiels ses
          identifiants de connexion et à signaler toute utilisation non
          autorisée de son compte.
        </p>
        <p>
          Fidmarket se réserve le droit de suspendre temporairement l'accès au
          service en cas de maintenance, de mise à jour, d'incident technique ou
          d'utilisation anormale.
        </p>
      </section>

      <section>
        <h2>3. Création et utilisation du compte commerçant</h2>
        <p>
          Le compte commerçant permet d'accéder aux fonctionnalités de gestion
          proposées par Fidmarket.
        </p>
        <p>
          Le commerçant est responsable de l'exactitude des informations
          renseignées dans son compte, notamment les informations relatives à
          son activité, ses marchés, ses clients, ses ventes et ses paramètres
          de fidélité.
        </p>
        <p>
          Toute utilisation du compte est réputée effectuée par le titulaire du
          compte, sauf preuve contraire.
        </p>
      </section>

      <section>
        <h2>4. Fonctionnalités proposées</h2>
        <p>Fidmarket peut notamment proposer les fonctionnalités suivantes :</p>
        <ul>
          <li>création et gestion de clients fidélité ;</li>
          <li>utilisation de cartes physiques ou digitales ;</li>
          <li>lecture de QR codes ;</li>
          <li>attribution et suivi de points fidélité ;</li>
          <li>enregistrement de ventes avec ou sans carte ;</li>
          <li>gestion des journées de marché ;</li>
          <li>clôture de journée ;</li>
          <li>statistiques commerciales ;</li>
          <li>prévisions indicatives ;</li>
          <li>publication d'annonces commerçants ;</li>
          <li>génération de documents ou factures selon les modules disponibles.</li>
        </ul>
        <p>
          Les fonctionnalités peuvent évoluer dans le temps. Fidmarket peut
          ajouter, modifier ou supprimer certaines fonctionnalités afin
          d'améliorer le service.
        </p>
      </section>

      <section>
        <h2>5. Cartes de fidélité et QR codes</h2>
        <p>
          Fidmarket permet d'utiliser des cartes de fidélité physiques ou
          digitales associées à des QR codes.
        </p>
        <p>
          Le commerçant est responsable de la distribution, de l'activation et
          de l'utilisation des cartes auprès de ses clients.
        </p>
        <p>
          Les QR codes et liens publics associés aux cartes permettent aux
          clients d'accéder à certaines informations liées à leur fidélité. Le
          commerçant doit veiller à utiliser ces supports de manière conforme à
          son activité et à la réglementation applicable.
        </p>
      </section>

      <section>
        <h2>6. Données clients et responsabilité du commerçant</h2>
        <p>
          Le commerçant est responsable des données clients qu'il saisit ou
          importe dans Fidmarket.
        </p>
        <p>
          Il s'engage à informer ses clients de l'utilisation de leurs données
          dans le cadre du programme de fidélité et à respecter la réglementation
          applicable en matière de protection des données personnelles.
        </p>
        <p>
          Fidmarket met à disposition des outils techniques permettant la
          gestion du programme de fidélité, mais ne se substitue pas au
          commerçant dans ses obligations légales vis-à-vis de ses clients.
        </p>
      </section>

      <section>
        <h2>7. Annonces publiées par les commerçants</h2>
        <p>
          Le service peut permettre au commerçant de publier des annonces
          visibles sur les cartes digitales de ses clients.
        </p>
        <p>
          Le commerçant est seul responsable du contenu des annonces publiées.
          Il s'engage à ne pas publier de contenu illicite, trompeur, injurieux,
          discriminatoire, contraire à l'ordre public ou portant atteinte aux
          droits de tiers.
        </p>
        <p>
          Fidmarket se réserve le droit de retirer ou désactiver toute annonce
          manifestement abusive ou non conforme.
        </p>
      </section>

      <section>
        <h2>8. Prévisions et statistiques</h2>
        <p>
          Les statistiques et prévisions proposées par Fidmarket sont fournies
          à titre indicatif.
        </p>
        <p>
          Elles peuvent être basées sur l'historique des ventes, les journées de
          marché, les données saisies par le commerçant ou d'autres paramètres
          disponibles.
        </p>
        <p>
          Fidmarket ne garantit ni l'exactitude absolue des prévisions, ni
          l'atteinte d'un chiffre d'affaires, d'un volume de ventes ou d'un
          résultat commercial déterminé.
        </p>
        <p>
          Le commerçant reste seul responsable de ses décisions commerciales, de
          ses stocks, de ses prix et de son organisation.
        </p>
      </section>

      <section>
        <h2>9. Disponibilité du service</h2>
        <p>
          Fidmarket met en œuvre des moyens raisonnables pour assurer le bon
          fonctionnement et la disponibilité du service.
        </p>
        <p>
          Toutefois, le service peut être temporairement indisponible en raison
          d'opérations de maintenance, de mises à jour, de pannes, de contraintes
          techniques, d'interruptions réseau ou de tout événement indépendant de
          la volonté de Fidmarket.
        </p>
        <p>
          Fidmarket ne peut être tenu responsable des conséquences d'une
          indisponibilité temporaire du service.
        </p>
      </section>

      <section>
        <h2>10. Obligations de l'utilisateur</h2>
        <p>
          L'utilisateur s'engage à utiliser Fidmarket conformément à sa
          destination et aux présentes CGU.
        </p>
        <p>Il s'interdit notamment :</p>
        <ul>
          <li>d'utiliser le service à des fins frauduleuses ou illicites ;</li>
          <li>de tenter d'accéder aux comptes ou données d'autres utilisateurs ;</li>
          <li>de perturber le fonctionnement du service ;</li>
          <li>de saisir volontairement des informations fausses, trompeuses ou illicites ;</li>
          <li>de porter atteinte aux droits de Fidmarket ou de tiers.</li>
        </ul>
      </section>

      <section>
        <h2>11. Propriété intellectuelle</h2>
        <p>
          L'ensemble des éléments composant Fidmarket, notamment les interfaces,
          textes, graphismes, logos, marques, fonctionnalités, codes, bases de
          données et documents, sont protégés par les droits de propriété
          intellectuelle.
        </p>
        <p>
          Toute reproduction, modification, diffusion ou exploitation non
          autorisée de tout ou partie du service est interdite.
        </p>
        <p>
          L'utilisation du service ne confère aucun droit de propriété à
          l'utilisateur sur Fidmarket.
        </p>
      </section>

      <section>
        <h2>12. Données personnelles</h2>
        <p>
          L'utilisation de Fidmarket peut impliquer le traitement de données
          personnelles.
        </p>
        <p>
          Les modalités de traitement des données personnelles sont précisées
          dans la politique de confidentialité ou tout document équivalent mis à
          disposition par Fidmarket.
        </p>
        <p>
          Pour toute demande relative aux données personnelles, l'utilisateur
          peut contacter Fidmarket à l'adresse suivante :
          <a href="mailto:contact@fidmarket.fr">contact@fidmarket.fr</a>.
        </p>
      </section>

      <section>
        <h2>13. Facturation et abonnement</h2>
        <p>
          Certaines fonctionnalités de Fidmarket peuvent être proposées dans le
          cadre d'un abonnement ou d'une offre commerciale spécifique.
        </p>
        <p>
          Les conditions financières, la durée, les modalités de paiement et les
          éventuelles conditions de résiliation sont précisées dans le devis, le
          contrat, la facture ou tout document commercial applicable.
        </p>
        <p>
          Sauf mention contraire, l'accès au service peut être suspendu en cas
          de défaut de paiement.
        </p>
      </section>

      <section>
        <h2>14. Limitation de responsabilité</h2>
        <p>Fidmarket fournit un outil d'aide à la gestion commerciale et à la fidélisation.</p>
        <p>Fidmarket ne peut être tenu responsable :</p>
        <ul>
          <li>des erreurs de saisie effectuées par le commerçant ;</li>
          <li>de l'utilisation incorrecte du service ;</li>
          <li>des décisions commerciales prises à partir des statistiques ou prévisions ;</li>
          <li>d'une perte de chiffre d'affaires ;</li>
          <li>d'un litige entre le commerçant et ses clients ;</li>
          <li>d'une utilisation non conforme des cartes, QR codes ou annonces ;</li>
          <li>d'un cas de force majeure ou d'un événement extérieur.</li>
        </ul>
      </section>

      <section>
        <h2>15. Modification des CGU</h2>
        <p>
          Fidmarket se réserve le droit de modifier les présentes CGU à tout
          moment afin de les adapter à l'évolution du service, de la
          réglementation ou de son activité.
        </p>
        <p>
          La version applicable est celle disponible en ligne au moment de
          l'utilisation du service.
        </p>
      </section>

      <section>
        <h2>16. Contact</h2>
        <p>
          Pour toute question relative aux présentes CGU ou au service
          Fidmarket, l'utilisateur peut contacter Fidmarket à l'adresse suivante :
        </p>
        <p><a href="mailto:contact@fidmarket.fr">contact@fidmarket.fr</a></p>
      </section>

      <section>
        <h2>17. Droit applicable</h2>
        <p>Les présentes CGU sont soumises au droit français.</p>
        <p>
          En cas de litige, les parties s'efforceront de rechercher une solution
          amiable avant toute action judiciaire.
        </p>
      </section>
    </article>
  </main>
</template>

<script>
export default {
  name: 'CGUView'
}
</script>

<style scoped>
.legal-page {
  --cream: #F5EDD6;
  --forest: #1A3A2A;
  min-height: 100vh;
  background: var(--cream);
  padding: clamp(28px, 6vw, 72px) clamp(18px, 5vw, 40px);
}

.legal-content {
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
}

.back-link {
  display: inline-block;
  margin-bottom: clamp(36px, 7vw, 64px);
  color: var(--forest);
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
}

.back-link:hover {
  text-decoration: underline;
}

h1,
h2,
a {
  color: var(--forest);
}

h1 {
  margin: 0 0 12px;
  font-size: clamp(30px, 6vw, 48px);
  letter-spacing: 0.04em;
}

.update-date {
  margin-bottom: clamp(36px, 7vw, 56px);
  font-weight: 600;
}

section {
  margin-bottom: 34px;
}

h2 {
  margin: 0 0 12px;
  font-size: clamp(20px, 4vw, 25px);
}

p,
li {
  color: #33483c;
  font-size: clamp(15px, 2.5vw, 17px);
  line-height: 1.75;
}

p {
  margin: 0 0 12px;
}

ul {
  margin: 0 0 12px;
  padding-left: 24px;
}

li {
  margin-bottom: 5px;
}

@media (max-width: 480px) {
  .legal-page {
    padding-top: 24px;
  }

  section {
    margin-bottom: 28px;
  }
}
</style>
